import { SelectContentProps } from 'components/ui/Forms';
import { CancelationReason } from 'contracts/CancelationReasons';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useCancelationReason() {
  const { token } = useAuth();
  const getCancelationReasons = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(
      `/cancelation-reasons?excludeBlocked=true&asList=1&orderBy=name&direction=asc`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data.map((reason: CancelationReason) => ({
      value: reason.id,
      name: reason.name,
    }));
  };

  return { getCancelationReasons };
}
